<div class="img-auth"></div>
<!--? CONTAINER -->
<div class="container-flex">
    <div class="container-auth">
        <!--? LOGO | ROUTER OUTLET -->
        <div class="logo-router-outlet">
            <!-- LOGO -->
            <div class="logo-auth" routerLink="/"></div>
            
            <!-- LOGIN -->
            <router-outlet></router-outlet>

        </div>
        <!--? FOOTER -->
        <div class="flex-align">
            <footer></footer>
        
        </div>
    </div>
</div>
